import { create } from 'zustand'

const THEME_KEY = 'crm_theme_preference'

function getEffective(pref) {
  if (pref === 'auto') {
    return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light'
  }
  return pref
}

function applyTheme(theme) {
  if (theme === 'dark') {
    document.documentElement.classList.add('dark')
  } else {
    document.documentElement.classList.remove('dark')
  }
}

const useThemeStore = create((set, get) => {
  const saved = localStorage.getItem(THEME_KEY) || 'auto'
  const effective = getEffective(saved)
  applyTheme(effective)

  const mq = window.matchMedia('(prefers-color-scheme: dark)')
  mq.addEventListener('change', () => {
    if (get().preference === 'auto') {
      const eff = getEffective('auto')
      applyTheme(eff)
      set({ effectiveTheme: eff })
    }
  })

  return {
    preference: saved,
    effectiveTheme: effective,
    cycleTheme: () => {
      const prev = get().preference
      const next = prev === 'auto' ? 'light' : prev === 'light' ? 'dark' : 'auto'
      localStorage.setItem(THEME_KEY, next)
      const eff = getEffective(next)
      applyTheme(eff)
      set({ preference: next, effectiveTheme: eff })
    },
  }
})

export default useThemeStore
